
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { isMobile, isTablet } from "mobile-device-detect";
import LazyImage from "./../LazyImage.vue";
import Slick from "vue-slick";
import { apiFetchAminityInfo } from "../../api";
import { LotPosition, AmenityInfo, Amenity } from "./../../types";
import { Scalers } from "./../../constant";
import LeftArrowIcon from "@/assets/icons/LeftArrow.vue";
import {
addImageScaler,
  calcZoom,
  getPlatMapModalPosition,
  getPlatMapModalPositionMobile,
  getTouchesCenter,
  getZoomDistance,
} from "./../../core";
@Component({
  components: {
    LazyImage,
    Slick,
    LeftArrowIcon
  },
})
export default class PlatmapAmenityModal extends Vue {
  $refs!: any;
  sliderOptions: any = {
    slidesToShow: 1,
    infinite: false,
  };
  private amenityTitle = "";
  private amenityCaption = "";
  private nextAmenityName = '';
  @Prop() amenityInfo: Array<AmenityInfo>;
  @Prop() private amenityId!: string
  @Prop() private uniqueAminity!: Array<string>;
  @Prop() private isKioskMode!: boolean;
  @Prop() private amenities!: Array<Amenity>
  @Prop(Function) loadNewAmenity!: () => void;
  mounted() {
    this.setAmenityTitleAndCaption();
    this.setNextAmenityName();
  }

  setNextAmenityName() {
    let currentIndex = this.uniqueAminity.indexOf(this.amenityId);
    const nextIndex = ++currentIndex % this.uniqueAminity.length;
    const amenityId = this.uniqueAminity[nextIndex];
    const nextAminity = this.amenities.filter((x) => x.id === amenityId);
    if (nextAminity.length) this.nextAmenityName = nextAminity[0].title;
    else this.nextAmenityName = "";
  }

  setAmenityTitleAndCaption() {
    for (const amenityInfo of this.amenityInfo) {
      if (!this.amenityTitle && amenityInfo.title) this.amenityTitle = amenityInfo.title;
      if (!this.amenityCaption && amenityInfo.caption)
        this.amenityCaption = amenityInfo.caption;
    }
  }
  addScaler(url) {
    return addImageScaler(url);
  }
}
